/**
 * Coups de pouce — Attendu 1070 « Construire le symétrique d'une figure par
 * rapport à un axe sur quadrillage ».
 *
 * carreaux_saisie : le geste de comptage (perpendiculairement à l'axe, autant
 * de carreaux de l'autre côté, le double entre le point et son symétrique).
 * L'exemple (revue 2026-09-04) prend d'autres lettres (M, M′) : la réponse d'un
 * tirage dépend de sa propre figure, l'aide ne peut pas la servir.
 * bon_qcm_unique + bon_tableau_vf : entrée PARTAGÉE — vérification sommet par
 * sommet (autre côté, même distance) et le piège de la copie glissée.
 * SVG pas à pas pilotés par les flèches de la sheet (data-etapes / data-caption).
 *
 * Sans coup de pouce (pur rappel) : vf_tableau_vf.
 */

const SVG_CARREAUX = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Placer le symétrique d'un point sur quadrillage, en 3 étapes à faire défiler avec les flèches. Un quadrillage, un axe (d) vertical, un point M à gauche de l'axe. Étape 2 : on compte les carreaux de M jusqu'à l'axe, perpendiculairement à l'axe : 1, 2, 3, soit 3 carreaux. Étape 3 : on reporte 3 carreaux de l'autre côté de l'axe et on place M′ ; entre M et M′ il y a 3 plus 3 égale 6 carreaux. Même distance, de part et d'autre de l'axe">
  <style>
    @keyframes cp1070-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1070-pop { opacity: 0; animation: cp1070-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Où est le symétrique de M par rapport à (d) ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">De M jusqu'à l'axe : 3 carreaux</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="3" font-family="system-ui,sans-serif">M′ est à 3 carreaux, de l'autre côté</text>

  <!-- ── La figure (étape 1) : quadrillage 9 × 9 de 16 px, axe vertical ──── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <g stroke="#cbd5e1" stroke-width="1">
      <line x1="12" y1="40" x2="156" y2="40"/><line x1="12" y1="56" x2="156" y2="56"/><line x1="12" y1="72" x2="156" y2="72"/><line x1="12" y1="88" x2="156" y2="88"/><line x1="12" y1="104" x2="156" y2="104"/><line x1="12" y1="120" x2="156" y2="120"/><line x1="12" y1="136" x2="156" y2="136"/><line x1="12" y1="152" x2="156" y2="152"/><line x1="12" y1="168" x2="156" y2="168"/><line x1="12" y1="184" x2="156" y2="184"/>
      <line x1="12" y1="40" x2="12" y2="184"/><line x1="28" y1="40" x2="28" y2="184"/><line x1="44" y1="40" x2="44" y2="184"/><line x1="60" y1="40" x2="60" y2="184"/><line x1="76" y1="40" x2="76" y2="184"/><line x1="108" y1="40" x2="108" y2="184"/><line x1="124" y1="40" x2="124" y2="184"/><line x1="140" y1="40" x2="140" y2="184"/><line x1="156" y1="40" x2="156" y2="184"/>
    </g>
    <line x1="92" y1="36" x2="92" y2="188" stroke="#DC2626" stroke-width="2.2"/>
    <text x="92" y="201" font-size="12" font-weight="700" fill="#DC2626" text-anchor="middle">(d)</text>
    <circle cx="44" cy="104" r="3" fill="#1e293b"/>
    <text x="35" y="97" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">M</text>
  </g>

  <!-- ── On compte jusqu'à l'axe (étape 2) ────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1070-pop">
      <line x1="44" y1="104" x2="92" y2="104" stroke="#1D9E75" stroke-width="2.4" stroke-dasharray="4 2"/>
      <text x="52" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">1</text>
      <text x="68" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">2</text>
      <text x="84" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">3</text>
      <text x="176" y="66" font-size="11.5" font-weight="700" fill="#1D9E75">On compte les carreaux</text>
      <text x="176" y="81" font-size="11.5" font-weight="700" fill="#1D9E75">de M jusqu'à l'axe,</text>
      <text x="176" y="96" font-size="11.5" font-weight="700" fill="#1D9E75">perpendiculairement :</text>
      <text x="176" y="111" font-size="11.5" font-weight="700" fill="#1D9E75">1, 2, 3 : 3 carreaux ✓</text>
      <text x="176" y="130" font-size="11" font-weight="600" fill="#B45309">(tout droit, jamais</text>
      <text x="176" y="143" font-size="11" font-weight="600" fill="#B45309">en biais)</text>
    </g>
  </g>

  <!-- ── On reporte de l'autre côté (étape 3) ─────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1070-pop">
      <line x1="92" y1="104" x2="140" y2="104" stroke="#1D9E75" stroke-width="2.4" stroke-dasharray="4 2"/>
      <text x="100" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">1</text>
      <text x="116" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">2</text>
      <text x="132" y="99" font-size="10" font-weight="700" fill="#1D9E75" text-anchor="middle">3</text>
      <circle cx="140" cy="104" r="3" fill="#1D9E75"/>
      <text x="150" y="97" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle">M′</text>
      <text x="176" y="166" font-size="11.5" font-weight="800" fill="#1D9E75">On reporte 3 carreaux</text>
      <text x="176" y="181" font-size="11.5" font-weight="800" fill="#1D9E75">de l'autre côté : M′ ✓</text>
      <text x="176" y="203" font-size="11.5" font-weight="700" fill="#1E3A8A">Entre M et M′ :</text>
      <text x="176" y="218" font-size="11.5" font-weight="700" fill="#1E3A8A">3 + 3 = 6 carreaux.</text>
      <text x="180" y="246" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Même distance, de part et d'autre de l'axe.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const SVG_BON = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Reconnaître le bon symétrique, en 3 étapes à faire défiler avec les flèches. Un quadrillage, un axe (d) horizontal, un triangle RST au-dessus de l'axe : R à 1 carreau de l'axe, S à 3, T à 2. Deux figures proposées sous l'axe, numérotées 1 et 2. Étape 2 : sommet par sommet, dans la figure 1 chaque sommet est à la même distance de l'axe, de l'autre côté. Étape 3 : la figure 2 est la même figure glissée vers le bas, elle n'est pas retournée : S, le plus loin de l'axe, y est devenu le plus près. Retournée, pas glissée : la bonne est la figure 1">
  <style>
    @keyframes cp1070-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1070-pop { opacity: 0; animation: cp1070-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Quelle figure est le symétrique de RST ?</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Chaque sommet : même distance, autre côté</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="3" font-family="system-ui,sans-serif">② est glissée, pas retournée</text>

  <!-- ── La figure (étape 1) : quadrillage 12 × 9 de 14 px, axe horizontal ── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <g stroke="#cbd5e1" stroke-width="1">
      <line x1="10" y1="36" x2="178" y2="36"/><line x1="10" y1="50" x2="178" y2="50"/><line x1="10" y1="64" x2="178" y2="64"/><line x1="10" y1="78" x2="178" y2="78"/><line x1="10" y1="106" x2="178" y2="106"/><line x1="10" y1="120" x2="178" y2="120"/><line x1="10" y1="134" x2="178" y2="134"/><line x1="10" y1="148" x2="178" y2="148"/><line x1="10" y1="162" x2="178" y2="162"/>
      <line x1="10" y1="36" x2="10" y2="162"/><line x1="24" y1="36" x2="24" y2="162"/><line x1="38" y1="36" x2="38" y2="162"/><line x1="52" y1="36" x2="52" y2="162"/><line x1="66" y1="36" x2="66" y2="162"/><line x1="80" y1="36" x2="80" y2="162"/><line x1="94" y1="36" x2="94" y2="162"/><line x1="108" y1="36" x2="108" y2="162"/><line x1="122" y1="36" x2="122" y2="162"/><line x1="136" y1="36" x2="136" y2="162"/><line x1="150" y1="36" x2="150" y2="162"/><line x1="164" y1="36" x2="164" y2="162"/><line x1="178" y1="36" x2="178" y2="162"/>
    </g>
    <line x1="6" y1="92" x2="182" y2="92" stroke="#DC2626" stroke-width="2.2"/>
    <text x="171" y="87" font-size="11" font-weight="700" fill="#DC2626" text-anchor="middle">(d)</text>
    <!-- RST -->
    <polygon points="24,78 52,50 80,64" fill="#DBEAFE" stroke="#1E3A8A" stroke-width="2" stroke-linejoin="round"/>
    <circle cx="24" cy="78" r="2.4" fill="#1e293b"/><circle cx="52" cy="50" r="2.4" fill="#1e293b"/><circle cx="80" cy="64" r="2.4" fill="#1e293b"/>
    <text x="16" y="75" font-size="12" font-weight="700" fill="#1e293b" text-anchor="middle">R</text>
    <text x="52" y="45" font-size="12" font-weight="700" fill="#1e293b" text-anchor="middle">S</text>
    <text x="89" y="61" font-size="12" font-weight="700" fill="#1e293b" text-anchor="middle">T</text>
    <!-- candidat ① : le symétrique -->
    <polygon points="24,106 52,134 80,120" fill="none" stroke="#64748b" stroke-width="2" stroke-dasharray="5 3" stroke-linejoin="round"/>
    <text x="52" y="176" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">①</text>
    <!-- candidat ② : la copie glissée -->
    <polygon points="94,134 122,106 150,120" fill="none" stroke="#64748b" stroke-width="2" stroke-dasharray="5 3" stroke-linejoin="round"/>
    <text x="122" y="176" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">②</text>
  </g>

  <!-- ── Sommet par sommet (étape 2) ─────────────────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1070-pop">
      <g stroke="#1D9E75" stroke-width="2" stroke-dasharray="3 2">
        <line x1="24" y1="78" x2="24" y2="106"/><line x1="52" y1="50" x2="52" y2="134"/><line x1="80" y1="64" x2="80" y2="120"/>
      </g>
      <g font-size="9.5" font-weight="700" fill="#1D9E75" text-anchor="middle">
        <text x="30" y="88">1</text><text x="30" y="103">1</text>
        <text x="58" y="72">3</text><text x="58" y="116">3</text>
        <text x="86" y="80">2</text><text x="86" y="110">2</text>
      </g>
      <circle cx="24" cy="106" r="2.6" fill="#1D9E75"/><circle cx="52" cy="134" r="2.6" fill="#1D9E75"/><circle cx="80" cy="120" r="2.6" fill="#1D9E75"/>
      <text x="190" y="60" font-size="11.5" font-weight="700" fill="#1D9E75">Sommet par sommet :</text>
      <text x="190" y="75" font-size="11.5" font-weight="700" fill="#1D9E75">R à 1 carreau de l'axe,</text>
      <text x="190" y="90" font-size="11.5" font-weight="700" fill="#1D9E75">S à 3, T à 2.</text>
      <text x="190" y="108" font-size="11.5" font-weight="700" fill="#1D9E75">Dans ①, chaque sommet</text>
      <text x="190" y="123" font-size="11.5" font-weight="700" fill="#1D9E75">est à la même distance,</text>
      <text x="190" y="138" font-size="11.5" font-weight="700" fill="#1D9E75">de l'autre côté ✓</text>
    </g>
  </g>

  <!-- ── Le piège de la copie glissée (étape 3) ───────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1070-pop">
      <polygon points="94,134 122,106 150,120" fill="#FEF3C7" stroke="#B45309" stroke-width="2.2" stroke-linejoin="round"/>
      <text x="190" y="166" font-size="11.5" font-weight="800" fill="#B45309">② est la même figure,</text>
      <text x="190" y="181" font-size="11.5" font-weight="800" fill="#B45309">juste glissée : elle</text>
      <text x="190" y="196" font-size="11.5" font-weight="800" fill="#B45309">n'est pas retournée ✗</text>
      <text x="190" y="214" font-size="11" font-weight="600" fill="#B45309">(S, le plus loin de l'axe,</text>
      <text x="190" y="227" font-size="11" font-weight="600" fill="#B45309">y est devenu le plus près)</text>
      <text x="180" y="246" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Retournée, pas glissée : la bonne est ①.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_BON = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**Un point à la fois** : on place le symétrique de chaque sommet en comptant les carreaux perpendiculairement à l'axe, puis on relie les points dans le même ordre.",
                "**Deux vérifications pour chaque sommet** : il est de **l'autre côté** de l'axe, et à la **même distance** de l'axe que le sommet de départ.",
                "**La figure est retournée, pas glissée** : un symétrique n'est jamais une copie simplement décalée. Ce qui touchait l'axe touche encore l'axe.",
                "**Un point sur l'axe** est son propre symétrique : il ne bouge pas.",
                "**Ce qui ne change pas** : les longueurs, les angles et l'aire. Un côté de 2 carreaux reste un côté de 2 carreaux.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_BON },
    ],
};

const AIDE_CARREAUX = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                "**Compter** : on va du point A jusqu'à l'axe en comptant les carreaux **perpendiculairement** à l'axe (tout droit, jamais en biais quand l'axe est vertical ou horizontal).",
                "Le symétrique A′ est de **l'autre côté** de l'axe, à **autant de carreaux** que A.",
                "Entre A et A′, on compte donc **le double** : de A à l'axe, puis de l'axe à A′.",
                "**Axe en diagonale** : on ne compte plus horizontalement, on rejoint l'axe en suivant l'autre diagonale du quadrillage.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_CARREAUX },
    ],
};

const CP_1070 = {
    carreaux_saisie: AIDE_CARREAUX,
    bon_qcm_unique: AIDE_BON,
    bon_tableau_vf: AIDE_BON,
};

export default CP_1070;
